import { getGPUTier } from 'detect-gpu';

const getGpu = async () => {
  return await getGPUTier();
};

export default getGpu;